// Builds the overlay: a fixed full-page cover holding the player iframe and a
// spinner, parked off-screen until the overlay opens.
import * as embedUtils from "@/modules/embedUtils";

/** The cover and player iframe that setupOverlayFrame builds. */
export interface OverlayFrame {
  coverModal: HTMLDivElement;
  iFrame: HTMLIFrameElement;
}

/** The Popover fields the overlay frame sets up. */
export interface OverlayFrameState {
  _coverModal: HTMLDivElement | null;
  _iFrame: HTMLIFrameElement | null;
  _spinner: HTMLDivElement | null;
  _onUnload: (e?: Event) => void;
}

function overlayInnerHtml() {
  const innerHtml = `\
	    <iframe src="about:blank" allow="microphone" width="100%" height="100%" frameborder="0" style="display:block;border:0"></iframe>\
	    ${embedUtils.spinner()}`;

  return innerHtml;
}

export function setupOverlayFrame(popover: OverlayFrameState): OverlayFrame {
  // PREPARE DIV INNER HTML
  // We find these with getElementsByTagName based on their position in the mix.
  // If the relative position changes, we will need to update the code below to find them.
  /*jshint multistr: true */

  // DROP IN MODAL SCREEN COVER DIV CODE
  popover._coverModal = document.createElement("div");
  popover._coverModal.id = "pixmoto_cover_modal";
  popover._coverModal.style.zIndex = "99999";
  popover._coverModal.style.position = "fixed";
  popover._coverModal.style.top = "0px";
  popover._coverModal.style.left = "-999999px";
  popover._coverModal.style.width = "100%";
  popover._coverModal.style.height = "100%";
  popover._coverModal.style.backgroundColor = "rgba(0,0,0,0.8)";

  // ADD MODAL DIV TO DOM
  popover._coverModal.innerHTML = overlayInnerHtml();
  document.body.appendChild(popover._coverModal);

  popover._iFrame = popover._coverModal.getElementsByTagName("iframe")[0];
  popover._spinner = popover._coverModal.getElementsByTagName("div")[0];

  popover._spinner.style.position = "absolute";
  popover._spinner.style.left = "0px";
  popover._spinner.style.top = "0px";
  popover._spinner.style.right = "0px";
  popover._spinner.style.bottom = "0px";

  popover._iFrame.style.display = "block";
  popover._iFrame.style.position = "absolute";
  popover._iFrame.style.top = "0px";
  popover._iFrame.style.width = "100%";
  popover._iFrame.style.height = "100%";
  popover._iFrame.style.border = "none";
  popover._iFrame.style.left = "-999999px";

  // IE 10 really really wants to hold onto the iframe contents (video) even when refreshing the page.
  // This seems to work around that bug.
  popover._iFrame.src = "about:blank";

  window.addEventListener("beforeunload", popover._onUnload);
  return { coverModal: popover._coverModal, iFrame: popover._iFrame };
}
